import { useState } from "react";
import { Eye, EyeOff, ShieldCheck } from "lucide-react";
import { Field } from "./Field";
import { PRO_LABELS } from "@/lib/labels";

export const ProCard = ({ orgKey, label, values, update, section = "pro" }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="xy-card p-5 md:p-6" data-testid={`pro-card-${orgKey}`}>
      <p className="font-display font-semibold text-slate-100 mb-4">{label}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field
          label="Username / Member ID"
          testid={`input-${orgKey}-username`}
          autoComplete="off"
          value={values.username}
          onChange={(e) => update(`${section}.${orgKey}.username`, e.target.value)}
        />
        <div>
          <label className="xy-label" htmlFor={`input-${orgKey}-password`}>
            Password
          </label>
          <div className="relative">
            <input
              id={`input-${orgKey}-password`}
              data-testid={`input-${orgKey}-password`}
              type={show ? "text" : "password"}
              autoComplete="new-password"
              className="xy-input pr-12"
              value={values.password}
              onChange={(e) => update(`${section}.${orgKey}.password`, e.target.value)}
            />
            <button
              type="button"
              data-testid={`btn-toggle-${orgKey}-password`}
              onClick={() => setShow((s) => !s)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-violet-300 transition-colors"
              aria-label={show ? "Hide password" : "Show password"}
            >
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const StepPro = ({ form, update }) => (
  <div className="space-y-6">
    <div className="flex items-start gap-3 rounded-xl border border-amber-400/20 bg-amber-400/5 px-4 py-3" data-testid="pro-confidential-notice">
      <ShieldCheck size={18} className="text-amber-300 mt-0.5 shrink-0" />
      <p className="text-xs text-slate-300 leading-relaxed">
        <span className="font-semibold text-amber-300">Confidential.</span> These credentials let Xyion register
        works, track royalties, and manage your publishing on your behalf. They are stored securely and are only
        visible to Xyion HQ. Skip any org you aren't registered with.
      </p>
    </div>
    {Object.entries(PRO_LABELS).map(([key, label]) => (
      <ProCard key={key} orgKey={key} label={label} values={form.pro[key]} update={update} />
    ))}
  </div>
);
